export default function validateFirstName({ firstName }: { firstName: string }) {
  if (firstName === "") {
    return [{ field: "firstName", error: "blank" }];
  }

  return [];
}
